import React, {useEffect, useRef} from 'react';
import blockStyles from '@baseStyles/block.scss';
import styles from './ContentA5.scss';
import ContentB1 from "@components/blocks/ContentB1/ContentB1";
import Slider from '@components/base/Slider/Slider';
import {useScreenSizeBelowBreakpoint} from '@hooks/useScreenSizeBelowBreakpoint';
import language from "@lang/language";

const ContentA5 = ({data, columns = 1, color = ''}) => {

	if (!data.blockContent) {
		return null;
	}

	const columnsMap = {
		1: '',
		2: styles.twoColumns,
		3: styles.threeColumns
	}
	const columnsClass = columnsMap[columns];

	const startSlider = useScreenSizeBelowBreakpoint(1200);
	const sliderRef = useRef(null);

	// Apply changes to slider when resize viewport without need to refresh page in browser
	useEffect(() => {
		if (sliderRef.current?.swiper) {
			const swiper = sliderRef.current.swiper;
			swiper.allowTouchMove = startSlider;
			swiper.startHintAnimation = startSlider;

			if (swiper.mousewheel) {
				if (startSlider) {
					swiper.params.mousewheel = {...swiper.params.mousewheel, forceToAxis: true, releaseOnEdges: true};
					swiper.mousewheel.enable();
				} else {
					swiper.mousewheel.disable();
				}
			}

			if (startSlider === false) {
				swiper.slideTo(0, 400, true);
			}
		}
	}, [startSlider]);

	return (
	  <>
		  <div className={blockStyles.baseContainerHolder}>
			  <ContentB1 title={data.blockTitle} desc={data.blockDesc} size={'800'}/>
		  </div>

		  <div className={`${styles.container} ${columnsClass} ${color ? styles[color] : ''}`}>
			  <Slider
				ref={sliderRef}
				slidesPerView={'auto'}
				autoplay={false}
				//startHintAnimation={startSlider}
				startHintAnimation={false}
				mousewheel={startSlider ? {forceToAxis: true, releaseOnEdges: true} : false}
				allowTouchMove={startSlider}>
				  {data.blockContent.map((val, k) => {
					  return (
						<div className={styles.boxContainer} key={k}>
							<div className={styles.textBox}>
								<div className={styles.titleHolder}>
									<h3 className={styles.title}>{val.title}</h3>

									{val.icon &&
									  <div className={styles.icon}>
										  <img
											src={val.icon}
											alt={val.title}
											title={val.title + language.shBGTitle}
											width={36}
											height={36}
										  />
									  </div>
									}
								</div>
								<div className={styles.text}>{val.text}</div>
							</div>
						</div>
					  );
				  })}
			  </Slider>
		  </div>
	  </>
	)
}

export default ContentA5;
